export function validTimeZone(value){
 if(typeof value!=='string'||value.length>100)return false;
 try{new Intl.DateTimeFormat('en',{timeZone:value});return true;}catch{return false;}
}
export function resolveTimeZone(value){
 if(value==='auto'||value==null){try{return Intl.DateTimeFormat().resolvedOptions().timeZone||'UTC';}catch{return 'UTC';}}
 return validTimeZone(value)?value:'UTC';
}
// Set only by the mobile/web UI root. Server calculations always pass a zone.
let selected='Europe/Copenhagen';
export function configureDisplayTimeZone(value){selected=resolveTimeZone(value);}
export function displayTimeZone(){return selected;}
const formatters=new Map();
export function zonedDateKey(value=new Date(),zone=selected){
 if(!formatters.has(zone))formatters.set(zone,new Intl.DateTimeFormat('en-CA',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit'}));
 const parts=formatters.get(zone).formatToParts(value),part=name=>parts.find(p=>p.type===name).value;
 return `${part('year')}-${part('month')}-${part('day')}`;
}
const boundaries=new Map();
function midnight(day,zone){
 const key=`${zone}:${day}`;if(boundaries.has(key))return boundaries.get(key);
 const nominal=Date.parse(`${day}T00:00:00Z`);let low=nominal-36*3600000,high=nominal+36*3600000;
 // Find the first instant belonging to the date. This handles half-hour zones,
 // 23/25-hour days and transitions occurring at midnight without fixed offsets.
 while(low<high){const middle=Math.floor((low+high)/2);if(zonedDateKey(new Date(middle),zone)<day)low=middle+1;else high=middle;}
 if(zonedDateKey(new Date(low),zone)!==day)throw new Error('invalid_local_date');
 const value=new Date(low).toISOString();if(boundaries.size>512)boundaries.clear();boundaries.set(key,value);return value;
}
export function zonedDayBounds(day,zone){
 if(!validTimeZone(zone)||!/^\d{4}-\d{2}-\d{2}$/.test(day))throw new Error('invalid_time_zone');
 const next=new Date(`${day}T12:00:00Z`);next.setUTCDate(next.getUTCDate()+1);
 return {startAt:midnight(day,zone),endAt:midnight(next.toISOString().slice(0,10),zone)};
}
